import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { IsSignedInGuard } from './guards/is-signed.guard';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './pages/authentication/login/login.component';
import { ForgotPasswordComponent } from './pages/authentication/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './pages/authentication/reset-password/reset-password.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LoginModule } from './pages/authentication/login/login.module';
import { ResetPasswordModule } from './pages/authentication/reset-password/reset-password.module';
import { ForgotPasswordModule } from './pages/authentication/forgot-password/forgot-password.module';
import { DashboardModule } from './pages/dashboard/dashboard.module';
import { StorageComponent } from './modules/storage/storage.component';

const routes: Routes = [
  {
    path: '',
    canActivate: [IsSignedInGuard],
    component: LayoutComponent,
    children: [
      {
        path: '',
        component: DashboardComponent,
        pathMatch: 'full'
      },
      {
        path: 'data',
        loadChildren: () => import('./data/data.module').then((m) => m.DataModule)
      },
      {
        path: 'storage',
        component: StorageComponent
      }
    ]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledNonBlocking',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      relativeLinkResolution: 'legacy'
    }),
    LoginModule,
    ResetPasswordModule,
    ForgotPasswordModule,
    DashboardModule
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
